import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import user from './user';
import media from './media';
import schedule from './schedule';
import room from './room';
import display from './display';
import company from './company';
import translation from './translation';
import school from './school';
import schoolquota from './schoolquota';
import group from './group';
import student from './student';
import occupation from './occupation';
import option from './option';

export default combineReducers({
	router: routerReducer,
	user,
	media,
	schedule,
	room,
	display,
	company,
  translation,
  school,
  schoolquota,
  group,
  student,
  occupation,
  option,
});
